import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {
  buildMemberQrPayload,
  decodeMemberQrPayload,
  DecodedMemberQr,
} from '../../../core/utils/member-card-qr.util';

@Component({
  selector: 'app-manual-member-qr',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './manual-member-qr.component.html',
  styleUrl: './manual-member-qr.component.css',
})
export class ManualMemberQrComponent {
  cardCode = '';
  licensePlate = '';
  encodedPayload = '';
  decodeInput = '';
  decoded: DecodedMemberQr | null = null;
  decodeError = '';

  /*#################################################### Function ################################################*/

  encodePayload(): void {
    const code = this.cardCode.trim();
    const plate = this.licensePlate.trim();
    if (!code || !plate) {
      this.encodedPayload = '';
      return;
    }
    this.encodedPayload = buildMemberQrPayload(code, plate);
  }

  decodePayload(): void {
    this.decodeError = '';
    this.decoded = null;
    const raw = this.decodeInput.trim();
    if (!raw) return;

    const result = decodeMemberQrPayload(raw);
    if (!result) {
      this.decodeError = 'รูปแบบไม่ถูกต้อง (ต้องมี $ และส่วน obfuscate)';
      return;
    }
    this.decoded = result;
  }

  copyEncoded(): void {
    if (!this.encodedPayload || !navigator.clipboard) return;
    navigator.clipboard.writeText(this.encodedPayload);
  }
}
